import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

import { TabItem } from '_components/tab-item'
import DeliveryContent from './delivery-content'

const MODAL_STYLES = {
  content: 'uup-delivery-modal__container',
  childWrapper: 'uup-delivery-modal__wrapper',
  innerWrapper: 'uup-delivery-modal__inner-wrapper',
  headerClose: 'uup-delivery-modal__close-button',
}

const TABS = {
  DELIVERY: 'Delivery',
}

const DeliveryModal = ({ open, schema, data, onClose, onSave }) => {
  const [tab, setTab] = useState(TABS.DELIVERY)

  return (
    <Modal isOpen={open} onClose={onClose} classes={MODAL_STYLES}>
      <div className="uup-delivery-modal__wrapper">
        <div className="uup-delivery-modal__tabs">
          <For each="tabName" of={Object.keys(TABS)}>
            <TabItem
              key={tabName}
              onClick={() => setTab(TABS[tabName])}
              isSelected={tab === TABS[tabName]}
              item={TABS[tabName]}
            />
          </For>
        </div>
        <div className="uup-delivery-modal__content">
          {tab === TABS.DELIVERY && (
            <DeliveryContent schema={schema} data={data} onSave={onSave} onClose={onClose} />
          )}
        </div>
      </div>
    </Modal>
  )
}

DeliveryModal.propTypes = {
  open: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
}

DeliveryModal.defaultProps = {
  open: false,
  data: {},
  onClose: () => {},
  onSave: () => {},
}

export default React.memo(DeliveryModal)
